import { Component } from 'lib'
import Image from 'Component/Asset/Image/Image'
import locale from 'Common/Locale/Locale'
import Icon from 'Component/Asset/Icon/Icon'

const operaClaimUrl = new URL(
  '/claim-opera',
  `https:${window.location.hostname
    .replace(/^local\./, 'dev.beta.')
    .replace(/\.legacy\./, '.beta.')}`
)

class OperaClaimReward extends Component {
  constructor (props) {
    super(props)

    this.claim = this.claim.bind(this)

    this.state = {
      isLoading: true
    }
  }

  componentDidMount () {
    fetch(operaClaimUrl, {
      credentials: 'include'
    })
      .then((response) => response.json())
      .then(({ isClaimed }) => {
        this.setState({ isClaimed })
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  claim () {
    if (this.isClaimed || this.isLoading) {
      return
    }

    this.setState({ isLoading: true })

    fetch(operaClaimUrl, {
      credentials: 'include',
      method: 'POST'
    })
      .then((response) => {
        this.setState({ isClaimed: response.ok })
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  render () {
    const { imageUrl, title } = this.props
    const { isClaimed, isLoading } = this.state

    return (
      <div class="reward">
        <div class="wrapper">
          <div class="title">{ title }</div>
          { !isLoading && (
            <div class="description">
              { isClaimed
                ? locale.translate(
                  'rewards.fulfillment.leagueOfLegends.success'
                )
                : locale.translate(
                  'rewards.fulfillment.leagueOfLegends.pending'
                ) }
            </div>
          ) }
          { isLoading ? (
            <div
              aria-label="Loading..."
              aria-live="polite"
              class="loader"
              role="status">
              <Icon name="lolesportsLogo"/>
              <Icon name="lolesportsLogo"/>
            </div>
          ) : (
            <button
              class="claim-now"
              disabled={ isClaimed }
              onClick={ this.claim }
              type="button">
              { isClaimed
                ? locale.translate('opera.claimed.button')
                : locale.translate('opera.claim.button') }
            </button>
          ) }
        </div>
        <div class="image">
          <Image class="img" src={ imageUrl } size="240x272"/>
        </div>
      </div>
    )
  }
}

export default OperaClaimReward
